const transactionManagerTabs = {
  CATEGORIZATION: 'CATEGORIZATION',
  TRANSACTIONS1099: 'TRANSACTIONS1099',
  ISSUES: 'ISSUES',
  FINANCIAL_PACKAGE_NOTES: 'FINANCIAL_PACKAGE_NOTES',
  FOLLOW_UP: 'FOLLOW_UP',
  PERSONAL_TRANSACTIONS: 'PERSONAL_TRANSACTIONS',
};

export default transactionManagerTabs;
